import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { adminAuthAPI } from '../api';
import { useAdminAuth } from '../App';

export default function Login() {
  const { login }    = useAdminAuth();
  const navigate     = useNavigate();
  const [form, setForm] = useState({ email: '', password: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const set = (k) => (e) => setForm(f => ({ ...f, [k]: e.target.value }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true); setError('');
    try {
      const { data } = await adminAuthAPI.login(form);
      if (data.success) {
        if (data.mustChangePassword) {
          // The backend set a restricted session cookie that only the
          // change-password route accepts — don't mark the admin as logged in yet.
          navigate('/force-password-change', { state: { admin: data.admin } });
        } else {
          login(data.admin);
          navigate('/dashboard');
        }
      } else setError(data.error || 'Login failed');
    } catch (err) { setError(err.response?.data?.error || 'Login failed'); }
    finally { setLoading(false); }
  };

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '1.5rem' }}>
      <div style={{ background: '#1e293b', border: '1px solid #334155', borderRadius: '8px', padding: '2rem', width: '100%', maxWidth: '380px' }}>
        <h1 style={{ fontSize: '1.3rem', marginBottom: '1.5rem' }}>ShopBook Admin</h1>
        <form onSubmit={handleSubmit}>
          <div className="form-group"><label>Email</label><input type="email" value={form.email} onChange={set('email')} required autoFocus /></div>
          <div className="form-group"><label>Password</label><input type="password" value={form.password} onChange={set('password')} required /></div>
          {error && <p style={{ color: '#ef4444', fontSize: '0.85rem', marginBottom: '0.75rem' }}>{error}</p>}
          <button type="submit" className="btn-primary" style={{ width: '100%' }} disabled={loading}>{loading ? 'Signing in…' : 'Sign In'}</button>
          <p style={{ marginTop: '1rem', fontSize: '0.82rem', textAlign: 'center', color: '#64748b' }}>
            <Link to="/forgot-password" style={{ color: '#60a5fa' }}>Forgot password?</Link>
          </p>
        </form>
      </div>
    </div>
  );
}
